import { useEffect } from "react";
import { createPortal } from "react-dom";
import ProductDetail from "../pages/ProductDetail";
import styles from "./QuickAddModal.module.css";

export default function QuickAddModal({ product, onClose }) {
  // Close on Escape + lock background scroll
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.shell} onClick={(e) => e.stopPropagation()}>
        <button className={styles.close} onClick={onClose} aria-label="Close">✕</button>
        <div className={styles.scroll}>
          <ProductDetail product={product} inModal onClose={onClose} />
        </div>
      </div>
    </div>,
    document.body
  );
}